import styled from 'styled-components';
import { LinkHoverCss } from '@/components/uielements/css';
import { LAYOUT, ORDER } from '@/constants/styles';

interface StyledEditMenuProps {
  isActive?: boolean;
}

export const StyledEditMenu = styled.div<StyledEditMenuProps>`
  border: 1px solid
    ${({ isActive, theme }) =>
      isActive ? theme.global.primary_active_color : theme.location_card.border_color};
  border-radius: ${({ theme }) => theme.location_card.border_radius}px;
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.location_card.background_color};
  position: relative;
  bottom: ${LAYOUT.GUTTER / 2}px;
  right: 0;
  z-index: ${ORDER.STORE_CARD_MENU};
`;

export const StyledEditMenuButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-family: ${({ theme }) => theme.primary_font.bold.font_family};
  padding: ${LAYOUT.GUTTER / 2}px ${LAYOUT.GUTTER}px;
  ${LinkHoverCss}
  text-decoration: none;

  &:not(:first-child) {
    border-top: 1px solid ${({ theme }) => theme.location_card.border_color};
  }
`;
